export default __webpack_public_path__ + "static/media/philandoCastile.6e49e417.png";